import React, { FC } from "react";
import { Form, Row, Col, Input, Select, DatePicker } from "antd";

interface EchsAdmissionDetailsProps {
  form: any;
  isEditable: boolean;
  isApproved: boolean;
  dateFormat: string;
}

const EchsAdmissionDetails: FC<EchsAdmissionDetailsProps> = ({
  form,
  isEditable,
  isApproved,
  dateFormat,
}) => {
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Admission Details
      </div>

      <Form form={form} layout="vertical" style={{ margin: "16px 0" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="ADMISSION DATE"
              name="dateOfAdmission"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input admission date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%", color: "black" }}
                showTime
                format={dateFormat}
                // disabled={!isEditable}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="DISCHARGE DATE"
              name="dateOfDischarge"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input discharge date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showTime
                format={dateFormat}
                disabled={!isEditable}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="DISCHARGE TYPE"
              name="dischargeType"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select discharge type",
                },
              ]}
            >
              <Select
                placeholder="Select discharge type"
                disabled={!isEditable}
                options={[
                  {
                    label: "Death Discharge",
                    value: "Death Discharge",
                  },
                  {
                    label: "LAMA",
                    value: "LAMA",
                  },
                  {
                    label: "NA",
                    value: "NA",
                  },
                  {
                    label: "Normal Discharge",
                    value: "Normal Discharge",
                  },
                  {
                    label: "Transfer to Other Hospital",
                    value: "Transfer to Other Hospital",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="ADMISSION AILMENT"
              name="admissionAilment"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input admission ailment",
                },
              ]}
            >
              <Input
                placeholder="Please input admission ailment"
                style={{ color: "black" }}
                disabled={!isEditable}
              />
            </Form.Item>
          </Col> */}
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="ROOM/WARD"
              name="room"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input room/ward",
                },
              ]}
            >
              <Input
                placeholder="Please input room/ward"
                style={{ color: "black" }}
                disabled={!isEditable}
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="TREATING DOCTOR"
              name="treatingDoctorName"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input treating doctor",
                },
              ]}
            >
              <Input
                placeholder="Please input treating doctor"
                style={{ color: "black" }}
                disabled={!isEditable}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="NET CLAIM AMOUNT"
              name="totalAmount"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input net claim amount",
                },
              ]}
            >
              <Input
                placeholder="Please input net claim amount"
                style={{ color: "black" }}
                disabled={!isEditable}
                type="number"
              />
            </Form.Item>
          </Col> */}
          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="ROOM TYPE"
              name="roomType"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please select room type",
                },
              ]}
            >
              <Select
                placeholder="Select room type"
                disabled={!isEditable}
                options={[
                  { label: "Private", value: "PRIVATE" },
                  { label: "Semi-Private", value: "SEMI-PRIVATE" },
                  { label: "General", value: "GENERAL" },
                ]}
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="SUBMISSION REMARKS"
              name="remarks"
              style={{ color: "black" }}
              rules={[
                {
                  required: true,
                  message: "Please input remarks",
                },
              ]}
            >
              <Input
                placeholder="Please input submission remarks"
                style={{ color: "black" }}
                disabled={!isEditable}
              />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
};

export default EchsAdmissionDetails;
